(() => {

  function initEgyptGlassProfessionalBox() {

    const productSections = document.querySelectorAll(
      '.product__info-container'
    );


    productSections.forEach((productInfo) => {

      if (
        productInfo.querySelector(
          '[data-eg-professional-box]'
        )
      ) {
        return;
      }


      const productForm =
        productInfo.querySelector(
          'product-form'
        ) ||
        productInfo.querySelector(
          'form[action*="/cart/add"]'
        );


      if (!productForm) {
        return;
      }


      const box =
        document.createElement('div');


      box.className =
        'eg-professional-box';


      box.setAttribute(
        'data-eg-professional-box',
        ''
      );


      box.innerHTML = `

        <div class="eg-professional-box__icon">
          <span>
            PRO
          </span>
        </div>


        <div class="eg-professional-box__content">

          <div class="eg-professional-box__title">
            ワークショップ・教室でご利用ですか？
          </div>


          <p class="eg-professional-box__text">

            少量のお試し注文からご利用いただけます。

            <br>

            継続利用やまとまった数量については、
            業務用価格もお気軽にご相談ください。

          </p>


          <a
            href="/pages/wholesale"
            class="eg-professional-box__link"
          >

            ワークショップ・業務用について

            <span
              class="eg-professional-box__arrow"
              aria-hidden="true"
            >
              →
            </span>

          </a>

        </div>

      `;


      const buyButtons =
        productInfo.querySelector(
          '.product-form__buttons'
        );


      if (buyButtons) {

        const parent =
          buyButtons.closest(
            'product-form'
          ) ||
          buyButtons.parentElement;


        parent.insertAdjacentElement(
          'afterend',
          box
        );


        return;

      }


      productForm.insertAdjacentElement(
        'afterend',
        box
      );

    });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initEgyptGlassProfessionalBox
  );


  document.addEventListener(
    'shopify:section:load',
    initEgyptGlassProfessionalBox
  );


  const observer =
    new MutationObserver(
      initEgyptGlassProfessionalBox
    );


  observer.observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

})();